export interface OtherAdditionItem {
  id: number;
  amount: number;
  type: OtherAdditionItemType;
  createdAt?: Date;
  updatedAt?: Date;
  payslipId: number;
}

export enum OtherAdditionItemType {
  TRAVEL_ALLOWANCE = "TRAVEL_ALLOWANCE",
  SKILL_ALLOWANCE = "SKILL_ALLOWANCE",
  MEDICAL_CLAIM = "MEDICAL_CLAIM",
  OTHER = "OTHER",
}

export const OtherAdditionItemTypeLabels: {
  [key in OtherAdditionItemType]: string;
} = {
  [OtherAdditionItemType.TRAVEL_ALLOWANCE]: "Travel Allowance",
  [OtherAdditionItemType.SKILL_ALLOWANCE]: "Skill Allowance",
  [OtherAdditionItemType.MEDICAL_CLAIM]: "Medical Claim",
  [OtherAdditionItemType.OTHER]: "Other",
};
